// extracted by mini-css-extract-plugin
export default {"checked":"styles_checked__Afivj","unChecked":"styles_unChecked__03-6T"};